import { UpdateBillingService } from './services/UpdateBillingService';
import type { Init } from './types';
import type { MergedDataReturnType, MergedHandlersReturnType } from '../../types';
import { WithApi } from '../WithApi';

export type UpdateBillingData = MergedDataReturnType<[UpdateBillingService]>;

export type UpdateBillingHandlers = MergedHandlersReturnType<[UpdateBillingService]>;

type TApi = ReturnType<UpdateBillingService['api']>;

export class UpdateBillingManager extends WithApi<TApi> {
  public updateBillingInit = ({ pageStore, mutations, t }: Init) => {
    const [updateBillingMutation] = mutations;

    const updateBilling = new UpdateBillingService(pageStore, updateBillingMutation, t);

    this.initApi({
      ...updateBilling.api(),
    });

    return {
      status: 'loaded',
      data: {
        ...updateBilling.data(),
      },
      handlers: {
        ...updateBilling.handlers(),
      },
    } as const;
  };
}
